/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["h1[_ngcontent-%COMP%]{color:#fff;text-align:center;font-size:100px}@media screen and (max-width:700px){h1[_ngcontent-%COMP%]{font-size:50px}}"];
export { styles as styles };
